import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/forecast";

export default function VoiceSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="用户口碑"
          title="蹲守的用户怎么说"
          description="我们更在意「看完之后知道该关注什么」，而不是制造一场热闹。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
          {testimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 80}>
              <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 md:p-7">
                <i className="ri-double-quotes-l text-3xl text-primary-300" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-bold text-background-50">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}